<template>
  <div class="login">
    <!-- 登录框 -->
  <div class="login_box_bg">
    <!-- 登录框左边图片 -->
    <div class="login_left"></div>
    <!-- 登录框右边框 -->
    <div class="login-box">
      <!-- 登录logo -->
      <div class="logo">
        <img src="../../assets/img/login_logo.png" style="position:absolute;top:20%;left:32%">
        <span class="upTitle1"> 账号登录 </span>
      </div>

      <div style="margin-top:50px;">
       
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
           <Row type="flex" justify="center" >
               <p style="color:red;font-weight:bold;" v-show="hasError">{{statusText}}</p>
           </Row>
          <Row type="flex" justify="center" align="middle">
              <Col span="13">
                  <FormItem  prop="loginName">
                    <Input type="text" v-model="formValidate.loginName" placeholder="请输入账号" class="loginNameText">
                      <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                  </FormItem>
                  <FormItem prop="password" >
                    <Input type="password" v-model="formValidate.password" placeholder="请输入密码" class="loginNameText">
                     <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                  </FormItem>
              </Col>
            </Row>
           
             <Row type="flex" justify="center" align="middle">
              <Col>
                <Button class="loginButton" type="warning"  @click="handleSubmit" >登录</Button>
              </Col>
          </Row>
        </Form>
      </div>
     </div>
    </div>
  </div>
</template> 

<script>
import { setCookie } from "@/utils/cookieUtils";
import {CURR_AREA_CODE } from '@/vuex/mutation-types'
import {SAVE_USER_INFO } from '@/vuex/mutation-types'
import {TOMCAT_INFO } from '@/vuex/mutation-types'
import md5 from 'js-md5';

export default {
  data() {
    return {
      
       hiddenLoginCode:'',
       statusText:'',
       hasError:false,
       formValidate: {
          loginName: '',
          password:'',
          inputLoginCode:'',
       },
        ruleValidate: {
          loginName: [{
            required: true,
            message: '登录名不能为空',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }],
         /*  inputLoginCode: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }], */
         
        },
    }
  },
  computed: {
    httpError() {
      return this.$store.state.httpError;
    }

  },
  
  methods: {
    handleSubmit() {
    
       this.$refs.formValidate.validate((valid) => {
        if (valid) {
             const loginName = this.formValidate.loginName;
            // const pass = this.formValidate.password;
             const inputLoginCode = this.formValidate.inputLoginCode;
             const pass=md5(escape(this.formValidate.password).replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F'));
           // const url = `/province/sys/login/doLogin?inputLoginCode=${inputLoginCode}&hiddenLoginCode=${this.hiddenLoginCode}&name=${loginName}&pwd=${pass}`
             const url = `/api/login`
             this.req({
                url: url,
                method: 'post',
                data:{
                  username :loginName  ,    //添加type后台查询返回省级信息
                  password: pass    //"21232f297a57a5a743894a0e4a801fc3",
                }
              }).then(response => {
               // console.log(response)
               if(response.data.code==200){
                 let wcToken = response.data.token
                //将用户token的key存入cookie
                setCookie("wcToken", wcToken, 1)
               
              //  this.$store.dispatch(SAVE_USER_INFO, userInfo)
                this.$store.dispatch(SAVE_USER_INFO, {
                    username: response.data.username,
                    auth:response.data.auth,
                })
               
                

                this.$router.replace("/home/main/task/TaskAdd")
                 
               
               }else{
                  this.hasError=true
                  this.statusText=response.data.msg
               }
               
             }).catch(error => {
               this.$Spin.hide();
               this.reponseData = "发生错误，无法显示内容"
             })
        }
      }) 
    },
    
  },
  mounted() {
    //重置登录错误提示信息为空
    this.$store.state.httpError=  {
      hasError: false,
      status: '',
      statusText: ''
    }
    //this.getLoginCode()
  },
  created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.handleSubmit();
        }
      }
  },
}
</script>

<style lang='less' scoped>
.upTitle {
  color: rgb(219, 198, 198); text-shadow: black 0.1em 0.1em 0.2em;
  padding-top: 50px;
  font-size: 35px;
  text-align: center;
}
.upTitle1 {
  color:#333; 
  // text-shadow: black 0.1em 0.1em 0.2em;
  font-size: 24px;
  font-weight:700;
  text-align: center;
}

.login {
  background-color: #2b4b6b ;
  background-size: 100% 100%;
  background-image: url("../../assets/img/login_bg.png");
  height: 100%;
  // 中间方框背景
  .login_box_bg{
    width:1150px;
    height:760px;
    top:0;
    left:0;
    right:0;
    bottom:0;
    margin:auto;
    background:url("../../assets/img/login_box_bg.png");
    background-size:100%;
    position:absolute;
  }
  //登录界面左边图片
  .login_left {
    background-image: url("../../assets/img/sucai.png") ;
    width:34%;
    height:56%;
    background-repeat:no-repeat;
    position:absolute;
    top:30%;
    left:10%;
  }
  //登录界面右边登录框
  .login-box {
    width: 44%;
    height: 60%;
    padding: 10px 40px;
    position: absolute;
    box-sizing: border-box;
    top: 36%;
    left: 72%;
    opacity: 0.8;
    transform: translateX(-50%);
    .logo {
      text-align: center;
      position: relative;
      left: 50%;
      transform: (translateX(-50%));
    }
  }
}
//input框
// .loginNameText{
//   width:380px;
//   left:-30%;
// }
// .loginNameText > inpuit{
//   height:100% !important;
// }
//button
.loginButton{
  width:160px;
  height:38px;
  background:#4d9cfb;
  border:0;
  border-radius:20px;
  margin-top:16px;
}

</style>
<style>
/* .ivu-input{
   height:100% !important;
}

.ivu-input-group-prepend{
  background:#dde1e7 !important;
} */
</style>


// WEBPACK FOOTER //
// src/pages/login/Login.vue